import { modals } from '@mantine/modals'

import ModalSuccessContent, {
  ModalSuccessProps,
} from './ModalNotificationContent'

const showModalNotification = (props: ModalSuccessProps) => {
  return modals.open({
    size: 'sm',
    centered: true,
    children: <ModalSuccessContent {...props} />,
    onClose: props.onClose,
    closeButtonProps: {
      onClick: props.onCancel,
    },
  })
}

export default showModalNotification
